import React from "react";
import classes from "./Pagination.module.scss";
import { ColorButtons } from "../../UIkit";

const Pagination = ({
  table,
  pageSize,
  setPageSize,
  pageIndex,
  setPageIndex,
}) => {
  const pageCount = table.getPageCount();
  const handlePageChange = (newPage) => {
    const validPage = Math.max(0, Math.min(newPage, table.getPageCount() - 1));
    table.setPageIndex(validPage);
    setPageIndex(validPage);
  };
  const totalRows = table.getFilteredRowModel().rows.length; // フィルタ後の全件数
  const startRow = pageIndex * pageSize + 1; // 現在のページの最初の行番号
  const endRow = Math.min(startRow + pageSize - 1, totalRows); // 現在のページの最後の行番号

  return (
    <div className={classes.pagination}>
      <div className={classes.pageButtons}>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(0)}
          disabled={!table.getCanPreviousPage()}
        >
          {"<<"}
        </button>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(pageIndex - 1)}
          disabled={!table.getCanPreviousPage()}
        >
          {"<"}
        </button>
        <span className={classes.pageInfo}>
          ページ{" "}
          <strong>
            {table.getState().pagination.pageIndex + 1} / {pageCount}
          </strong>
        </span>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(pageIndex + 1)}
          disabled={!table.getCanNextPage()}
        >
          {">"}
        </button>
        <button
          className={classes.pageButton}
          onClick={() => handlePageChange(table.getPageCount() - 1)}
          disabled={!table.getCanNextPage()}
        >
          {">>"}
        </button>
      </div>

      {/* <span className={classes.pageJump}>
        | ページ番号へ移動:{" "}
        <input
          type="number"
          defaultValue={table.getState().pagination.pageIndex + 1}
          onChange={(e) => {
            const page = e.target.value ? Number(e.target.value) - 1 : 0;
            table.setPageIndex(page);
          }}
          style={{ width: "50px" }}
        />
      </span> */}
      <div className={classes.pageStats}>
        <span>
          {startRow}-{endRow}件
        </span>{" "}
        / <span>{totalRows}件</span>
      </div>

      <select
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
          table.setPageSize(Number(e.target.value));
        }}
      >
        {[15, 30, 50].map((size) => (
          <option key={size} value={size}>
            {size} 件表示
          </option>
        ))}
      </select>
    </div>
  );
};

export default Pagination;
